import { BrowserProvider } from "ethers";

export interface PendingAsyncTask {
  status: "pending";
}

export interface LoadingAsyncTask {
  status: "loading";
}

export interface FailedAsyncTask<E> {
  error: E;
  status: "failed";
}

export interface SuccessfulAsyncTask<D> {
  data: D;
  status: "successful";
}

export interface ReloadingAsyncTask<D> {
  data: D;
  status: "reloading";
}

export type AsyncTask<D, E> =
  | PendingAsyncTask
  | LoadingAsyncTask
  | SuccessfulAsyncTask<D>
  | ReloadingAsyncTask<D>
  | FailedAsyncTask<E>;

interface OpenModal<D> {
  data: D;
  status: "open";
}

interface ClosedModal {
  status: "closed";
}

export type ModalState<D> = OpenModal<D> | ClosedModal;

export interface ConnectedProvider {
  address: string;
  provider: BrowserProvider;
  chainId: bigint;
}

export enum WalletEvent {
  ACCOUNTS_CHANGED = "accountsChanged",
  CHAIN_CHANGED = "chainChanged",
  DISCONNECT = "disconnect",
}

export interface Badge {
  key: "github" | "phone" | "twitter" | "on-chain" | "social-vouching";
  label: string;
  points?: string;
  isActive: boolean;
}

export interface BadgeVerifications {
  githubVerified: boolean;
  phoneVerified: boolean;
}

export type VerifiableCredential = {
  id: string;
  "@context": string[];
  type: string[];
  expirationDate: string;
  issuanceDate: string;
  issuer: string;
  credentialSubject: {
    id: string;
    score: number;
    type: string;
  };
  proof: {
    "@context": string[];
    type: string;
    cryptosuite: "merklize-sponge6-eth" | "merklize-sponge6-bjj";
    created: string;
    verificationMethod: string;
    proofPurpose: string;
    proofValue: string;
  };
};

export type ZkProof = {
  proof: {
    pi_a: [string, string, string];
    pi_b: [[string, string], [string, string], [string, string]];
    pi_c: [string, string, string];
    protocol: string;
    curve: string;
  };
  publicSignals: string[];
};
